import RouterOperativa from './RouterOperativa';
import NavigationItems from './../global/constants/navigation';

export default {
  pathBase: '/',
  componentRouter: RouterOperativa,
  navigationItems: NavigationItems
};
